'use strict';

import { environment } from 'environments/environment';
const { version: appVersion } = require('./../../../../../package.json');

const config: any = {        
    "app" : {
        "api": {
            "baseUrl": environment.apiBaseUrl || 'https://micro-nemo.comprodls.com/mobile-gateway/',
            "keyId": environment.userLoginKey
        },
        userlogin: {
            "key": environment.userLoginKey,
            "maxSessionLife" : ((environment.sessionExpiry || (1000 * 60 * 60 * 24 * 30)) + (1000 * 60 * 5)) 
        },
        version: appVersion,
    }
    
}

export default config;
